
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { EditorModule } from 'primeng/editor';
import Quill from 'quill';
import QuillBetterTable from 'quill-better-table';

Quill.register({
  'modules/better-table': QuillBetterTable,
}, true);

@Component({
  selector: 'app-reduced-editor',
  imports: [
    EditorModule,
    FormsModule
  ],
  templateUrl: './reduced-editor.html',
  styleUrl: './reduced-editor.scss'
})
export class ReducedEditor {
  @Input({ required: true }) public model!: string
  @Input() public disabled: boolean = false;
  @Input() public saveAble: boolean = false;
  @Output() public modelChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() public onSave: EventEmitter<string> = new EventEmitter<string>();

  protected isDirty: boolean = false;
  private quillInstance: any;

  public quillModules: any = {
    table: false,
    'better-table': {
      operationMenu: {
        items: {
          insertColumnLeft: {
            text: 'Spalte links einfuegen',
          },
          insertColumnRight: {
            text: 'Spalte rechts einfuegen',
          },
          insertRowUp: {
            text: 'Zeile oben einfuegen',
          },
          insertRowDown: {
            text: 'Zeile unten einfuegen',
          },
          mergeCells: {
            text: 'Zellen zusammenfuehren',
          },
          unmergeCells: {
            text: 'Zellen trennen',
          },
          deleteColumn: {
            text: 'Spalte löschen',
          },
          deleteRow: {
            text: 'Zeile löschen',
          },
          deleteTable: {
            text: 'Tabelle löschen',
          },
        },
      },
    },
    keyboard: {
      bindings: (QuillBetterTable as any).keyboardBindings,
    },
  };

  protected onEditorInit(event: any) {
    this.quillInstance = event?.editor ?? event;
  }

  protected insertTable() {
    const betterTable = this.quillInstance?.getModule('better-table');
    if (betterTable != null) {
      betterTable.insertTable(3, 3);
    }
  }

  protected save() {
    this.onSave.emit(this.model);
    this.isDirty = false;
  }
}
